import { createSlice } from '@reduxjs/toolkit';

import { ENUM__connection_state } from '../../enums/ENUM__connection_state';
import { ENUM__redux_slice } from '../_base/ENUM__redux_slice';
import { INIT_LOCAL__network_set_waiting_response } from './LOCAL__network_set_waiting_response';
import { init_local_network_set_avg_server_latency } from './local_network_set_avg_server_latency';
import { init_local_network_set_errors } from './local_network_set_errors';
import { init_local_network_set_state } from './local_network_set_state';
import { init_remote_network_connect } from './remote_network_connect';
import { STATE__network } from './STATE__network';

const initialState: STATE__network = {
  connect_attempts_after_last_disconnect: 0,
  state: ENUM__connection_state.DISCONNECTED,
  errors: [],
  avg_server_latency: 0,
  responses_ids__wait_to: new Set(),
};

export const slice_network = createSlice({
  name: ENUM__redux_slice.NETWORK,

  initialState,

  reducers: {
    set_waiting_response: INIT_LOCAL__network_set_waiting_response,
    set_avg_server_latency: init_local_network_set_avg_server_latency,
    setState: init_local_network_set_state,
    set_errors: init_local_network_set_errors,
  },

  extraReducers: builder => {
    init_remote_network_connect(builder);
  },
});
